import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const Wrap = styled.div`
    position: relative;
    overscroll-behavior: contain;
    font-size: 11px;

    .headers {
        top: 0;
        position: sticky;
        z-index: 1;
        background: #eee;

        .entry {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .sortButton {
                cursor: pointer;
                margin-left: 5px;
            }
        }
    }

    .tracks, .scroller {
        display: flex;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
    }

    .scroller {
        overflow-x: scroll;
    }

    .tracks {
        overflow: auto;
    }

    .scroller::-webkit-scrollbar {
        display: none;
    }

    .entry {
        min-width: 250px;
        max-width: 250px;
        min-height: 24px;
        max-height: 24px;
        padding: 5px;
        border: 0.5px solid #ebebeb;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`

const TableAdminData = (props) => {

    const [tableData, setTableData] = useState(props.data);
    const [columnToSortIndex, setColumnToSortIndex] = useState(props.sortByColumnIndex || 0);
    const [sortDirection, setSortDirection] = useState(1);
    const [scrollX, setScrollX] = useState(0);
    const headerRef = useRef(null);
    const contentRef = useRef(null);

    useEffect(() => {
        const _tableData = [...props.data].slice(1);
        _tableData.sort((a, b) => {
            if(!a[columnToSortIndex]) return 1 * sortDirection;
            if(!b[columnToSortIndex]) return -1 * sortDirection;
            return cellValue(a[columnToSortIndex]).localeCompare(cellValue(b[columnToSortIndex])) * sortDirection;
        })
        _tableData.unshift(props.data[0]);
        setTableData(_tableData);
    }, [props.data, columnToSortIndex, sortDirection])

    if(!props.data) return null;

    function onScroll(e){
        headerRef.current.scrollLeft = e.target.scrollLeft;
        contentRef.current.scrollLeft = e.target.scrollLeft;
        setScrollX(e.target.scrollLeft);
    }

    function transposeArray(arrOfArr) {
        const numRows = arrOfArr.length;
        const numCols = arrOfArr[0].length;
        const transposedArray = Array.from({ length: numCols }, () => []);
        for (let i = 0; i < numRows; i++) {
            for (let j = 0; j < numCols; j++) {
                transposedArray[j][i] = arrOfArr[i][j];
            }
        }
        return transposedArray;
    }

    function cellValue(cell){
        if(!cell) return "";
        if(cell.link === true){ return cell.value }
        return cell;
    }

    function cellObjectToHTML(cell){
        if(!cell) return "";
        if(cell.select === true){ 
            if(cell.defaultValue === "649ad901daa54132aca21cf1")console.log(cell)
            return (
            <select defaultValue={cell.defaultValue} onChange={cell.onChange} style={{margin:"0",padding:"0 20px 0 0 ",border:"none", borderRadius:"0", backgroundPositionY:"-3px", width:"250px"}}>
                {cell.values.sort((a,b) => a.value === cell.defaultValue ? -1 : 1).map(val => 
                    <option key={val.value} value={val.value}>{val.label}</option>
                )}
                {/* <option value="test">test</option> */}
            </select>
        )}
        if(cell.link === true){ return (
            <a href={cell.value} target="_blank" rel="noreferrer">accéder au lien -&gt;</a>
        )}
        return cell;
    }

    function sortByColumn(index){
        if(columnToSortIndex === index){
            setSortDirection(sortDirection * -1);
        } else {
            setColumnToSortIndex(index);
            setSortDirection(1);
        }
    }

    return (
        <Wrap X={scrollX}>
            <div className="headers" >
                <div className="scroller" onScroll={onScroll} ref={headerRef}>
                    {tableData[0].map((cell, index) => 
                        <div className="track entry" key={index}>
                            <span>{cell}</span><span className="sortButton" onClick={e => sortByColumn(index)}>{columnToSortIndex === index ? (sortDirection === 1 ? '↑' : '↓') : '↕' }</span>
                        </div>
                    )}
                </div>
            </div>
            <div className="tracks" onScroll={onScroll} ref={contentRef}>
                {transposeArray(tableData.slice(1)).map((row, index) =>
                    <div className="track" key={index}>
                        {row.map((cell, index) => 
                            <div className="entry" key={index}>{cellObjectToHTML(cell)}</div>
                        )}
                    </div>
                )}
            </div>
        </Wrap>
    )
}

export default TableAdminData;